import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { investmentPreferenceMasterData } from '../../redux-store/actions';
import {
    ApplicationProps,
    NexEdgeInvPrefObj,
    TypeInvPrefNexEdge,
    HeadingsObj,
    AssetAllObj,
} from '../../redux-store/types/api-types';

import { SubHeading } from '../investors/components';


export default function NexEdgeInvestmentPreference({
    application,
}: {
    application: ApplicationProps;
}): JSX.Element {
    const theme = useTheme();
    const {
        investmentpreferences = [],
        riskProfile
    } = application || {};

    const [invPrefData, setInvPrefData] = useState<NexEdgeInvPrefObj>({} as NexEdgeInvPrefObj);
    const [invPrefHeading, setInvPrefHeading] = useState<Array<HeadingsObj>>([]);
    const dispatch = useDispatch();

    const riskProfileType = riskProfile?.toLowerCase();

    useEffect(() => {
        (async function () {
            try {
                const response = (await dispatch(
                    investmentPreferenceMasterData()
                )) as unknown as TypeInvPrefNexEdge;

                const headings = response[riskProfileType as keyof TypeInvPrefNexEdge]?.headings;
                setInvPrefHeading(headings);

                if (investmentpreferences?.length > 0) {
                    setInvPrefData({
                        ...response[riskProfileType as keyof TypeInvPrefNexEdge],
                        asset_allocations: response[riskProfileType as keyof TypeInvPrefNexEdge]?.asset_allocations?.map(jsonObj => {
                            const existingInvestmentPreferenceObj = investmentpreferences.find(item => ((item?.question ?? "") === (jsonObj?.parameter ?? "")) &&
                                ((item?.headingKey ?? "") === (jsonObj?.headingKey ?? "")) &&
                                ((item?.subHeadingKey ?? "") === (jsonObj?.subHeadingKey ?? ""))) ?? {} as AssetAllObj
                            return {
                                ...(Object.keys(existingInvestmentPreferenceObj).length > 0 ?
                                    {
                                        ...existingInvestmentPreferenceObj,//needed for ids coming from api
                                        ...jsonObj,//needed for UI display
                                        parameter: existingInvestmentPreferenceObj?.question ?? '',
                                        guideline: existingInvestmentPreferenceObj?.answer ?? ''
                                    }
                                    : jsonObj
                                )
                            }
                        })
                    });
                } else {
                    setInvPrefData(response[riskProfileType as keyof TypeInvPrefNexEdge]);
                }
            } catch (e) {
                console.error((e as Error).message);
            }
        })();
    }, []);

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                })}
                mt={5}>
                <Box >
                    <Grid container>
                        <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                            Investment Preference
                        </Typography>
                        {invPrefHeading?.map((heading: any) => (
                            <>
                                <Grid item xs={12} sm={12} lg={12}>
                                    <SubHeading
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}>
                                        {heading?.heading}
                                    </SubHeading>
                                    <Typography variant='body_500' sx={{ color: `${theme.palette.text.secondary}` }}>
                                        {heading?.heading_text}
                                    </Typography>
                                </Grid>
                            </>
                        ))}

                        {/* Table */}

                        <TableContainer sx={{ mt: 6 }}>
                            <Table
                                sx={{
                                    border: "1px solid #ccc",
                                    "& td, & th": {
                                        border: "1px solid #ccc",
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            <Typography variant='h2'>Parameter</Typography>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography variant='h2'>Guideline</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {invPrefData?.asset_allocations?.map((row, index) => {
                                        if (row.isHeading || row.isSubHeading) {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        align={row.isSubHeading ? "left" : "center"}
                                                        colSpan={2}
                                                        style={{
                                                            fontWeight: "bold",
                                                            backgroundColor: row.isSubHeading ? "unset" : "#f0f0f0",
                                                        }}
                                                    >
                                                        {row.parameter}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }

                                        return (
                                            <TableRow key={index}>
                                                <TableCell align="center">
                                                    <Typography variant='body_500'>
                                                        {row?.parameter ?? "-"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row?.boldGuideline && row?.boldGuideline?.length > 0 && (
                                                        <Typography
                                                            variant='body_500'
                                                            sx={{ fontWeight: 'bold', mb: 1 }}
                                                        >
                                                            {row?.boldGuideline ?? "-"}
                                                        </Typography>
                                                    )}
                                                    <Typography variant='body_500'>
                                                        {row?.guideline ?? "-"}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}
